module.exports = __webpack_public_path__ + "media/src/images/zu_12question_snap01-5d7835c1938cf28147f718bff130a55f.png";